/*************************************************/
/* DROPDOWN BOXES                                    */
/*************************************************/

export function dropdownBoxes() {
    const ParentDropdownBox = '.dropdown-boxes__box';
    const DropdownBoxContent = '.dropdown-boxes__box-content';
    const ParentDropdownBoxEnterEvents = ['focusin', 'mouseenter']
    const ParentDropdownBoxExitEvents = ['focusout','mouseleave']

    const init = () => {
        const parentMenuItems = document.querySelectorAll(ParentDropdownBox);
        if (parentMenuItems.length > 0) {
            parentMenuItems.forEach(item => {

                ParentDropdownBoxEnterEvents.forEach(event => {
                    item.addEventListener(event, e => {
                        item.querySelector(DropdownBoxContent).classList.add("active");
                    });
                });

                ParentDropdownBoxExitEvents.forEach(event => {
                    item.addEventListener(event, e => {
                        item.querySelector(DropdownBoxContent).classList.remove("active");
                    });
                });

            });
        }
    };

    init();

}

